module.exports = __webpack_public_path__ + "media/hĕn láew yang têe hĕn née keu pláat-dtìk têe kwăeng pâa.401ce9ab.mp3";